/* eslint-disable react/prop-types */
import React, { useEffect, useMemo, useState } from "react";
import PropTypes from "prop-types";
import TablePaginate from "components/TablePaginate/TablePaginate";
import Button from "components/CustomButtons/Button.js";
import { Link } from "react-router-dom";
import { DeleteForever, Edit, FileCopy } from "@material-ui/icons";
import useConfirm from "hooks/useConfirm";
import { toast } from "react-toastify";
import { questService } from "services/questService";
import { Contract, ethers } from "ethers";
import { abi as erc20Abi } from "../../contracts/ERC20Mock.json";
import { SweepByLabel } from "./const";
import { makeStyles } from "@material-ui/core";
import Select from "components/Select/Select";
import CustomInput from "components/CustomInput/CustomInput";
import InputAdornment from "@material-ui/core/InputAdornment";
import Search from "@material-ui/icons/Search";
import { chainOptions } from "const";

const chainRpc = process.env.REACT_APP_CHAIN_PRC;

const getQuestAddress = (chainId) => {
  return chainOptions().find((c) => +c.value === +chainId)?.config?.questAddress;
};

const useStyles = makeStyles({
  filter: {
    display: "flex",
    gap: "40px",
  },
});

export default function QuestIndex() {
  const classes = useStyles();

  const [confirm, showConfirm] = useConfirm();
  const [items, setItems] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [size] = React.useState(10);
  const [chainId, setChainId] = React.useState("-1");
  const [search, setSearch] = React.useState("");
  const [count, setCount] = React.useState(0);
  const [questAddress, setQuestAddress] = useState("");

  useEffect(() => {
    (async () => {
      const address = await getQuestAddress(chainId);
      setQuestAddress(address);
    })();
  }, [chainId]);

  const getChainById = (id) => {
    const chain = chainOptions().find((c) => +c.value === +id);
    return chain ? chain.label : "Null";
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "ID",
        accessor: "questId",
      },
      {
        Header: "Collection",
        accessor: "targetCollection.name",
      },
      {
        Header: "Type",
        accessor: "type",
      },
      {
        Header: "Chain",
        accessor: "chainId",
        Cell: function Tier(cell) {
          return getChainById(cell.value);
        },
      },
      {
        Header: "Limit",
        Cell: Limit,
      },
      {
        Header: "Requirement",
        accessor: "requirement",
        Cell: Requirement,
      },
      {
        Header: "User",
        Cell: User,
      },

      {
        Header: "Reward",
        accessor: "rewardCoin",
        Cell: Reward,
      },
      {
        Header: "Status",
        accessor: "status",
        // eslint-disable-next-line react/prop-types
        Cell: ({ cell }) => (
          // eslint-disable-next-line react/prop-types
          <span>{cell.value.toUpperCase()}</span>
        ),
      },

      {
        Header: "Action",
        Cell: function remove({ cell }) {
          return (
            <Action
              cell={cell}
              handleDelete={(row) =>
                showConfirm("Are you sure remove ?", () => handleDelete(row._id))
              }
            />
          );
        },
      },
    ],
    [],
  );

  async function fetchQuests() {
    const payload = {
      search,
      page,
      size,
      chainId: +chainId,
    };
    if (!payload.chainId || payload.chainId === -1) delete payload.chainId;
    try {
      const { data } = await questService.list(payload);
      setItems(data);
      setCount(data?.paginate?.count || data.length);
      setPage(data?.paginate?.page || 1);
    } catch (e) {
      console.log(e);
    }
  }

  async function handleDelete(id) {
    try {
      await questService.remove(id);
      await fetchQuests();
      toast.success("Deleted quest");
    } catch (e) {
      console.log(e);
      toast.error("Cannot delete quest");
    }
  }

  React.useEffect(() => {
    fetchQuests();
  }, [page, size, search, chainId]);

  console.log({ confirm, address: questAddress });

  return (
    <div>
      {confirm}

      <h5>Contract: {questAddress}</h5>

      <Link to="/admin/quest/create">
        <Button color="info">Create new Quest</Button>
      </Link>

      <div className={classes.filter}>
        <CustomInput
          labelText="Search"
          id="search"
          formControlProps={{
            fullWidth: true,
          }}
          inputProps={{
            value: search,
            onChange: (e) => setSearch(e.target.value),
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
        />
        <Select
          label={"Chain"}
          value={chainId}
          onChange={setChainId}
          options={[{ value: "-1", label: "All" }, ...chainOptions()]}
        />
      </div>

      <TablePaginate
        count={count}
        page={page}
        setPage={setPage}
        size={size}
        columns={columns}
        data={items}
      />
    </div>
  );
}

function Action({ cell, handleDelete }) {
  return (
    <div className="actions-right">
      <Link to={"/admin/quest/edit/" + cell.row.original.id}>
        <Button justIcon round simple color="warning" className="edit">
          <Edit />
        </Button>
      </Link>
      <Button
        justIcon
        round
        simple
        onClick={() => handleDelete(cell.row.original)}
        color="danger"
        className="remove"
      >
        <DeleteForever />
      </Button>{" "}
    </div>
  );
}

Action.propTypes = {
  cell: PropTypes.any,
  handleDelete: PropTypes.func,
};

function User({ cell }) {
  return (
    <div>
      <div>
        <strong>Joined: </strong> {cell.row.original?.users?.length}
      </div>
      <div>
        <strong>Completed: </strong>{" "}
        {cell.row.original?.users?.filter((user) => user.winTime).length}
      </div>
      <div>
        <strong>Claimed: </strong> {cell.row.original?.users?.filter((user) => user.claimed).length}
      </div>
    </div>
  );
}

function Requirement({ cell }) {
  if (cell.row.original?.type === "sweep") {
    return <div> Sweep: {SweepByLabel[cell.row.original?.sweepBy]} NFT</div>;
  }

  return (
    <>
      {parseInt(cell?.value?.saleVolume) > 0 && (
        <div>
          - Sale volume: {cell.value.saleVolume}{" "}
          {process.env.REACT_APP_NETWORK === "polygon" ? "POL" : "CRO"}
        </div>
      )}
      {parseInt(cell?.value?.buyVolume) > 0 && (
        <div>
          - Buy volume: {cell.value.buyVolume}{" "}
          {process.env.REACT_APP_NETWORK === "polygon" ? "POL" : "CRO"}{" "}
        </div>
      )}
      {parseInt(cell?.value?.numberOfListings) > 0 && (
        <div>- Listings: {cell.value.numberOfListings} NFT</div>
      )}
      {parseInt(cell?.value?.numberOfPurchases) > 0 && (
        <div>- Buy NFT: {cell.value.numberOfPurchases} NFT</div>
      )}
      {parseInt(cell?.value?.numberOfSales) > 0 && (
        <div>- Sale NFT: {cell.value.numberOfSales} NFT</div>
      )}
    </>
  );
}

function Limit({ cell }) {
  return (
    <div>
      {cell.row.original.endTime && (
        <div>
          <strong>End:</strong> {new Date(cell.row.original.endTime).toLocaleString("en-US")}
        </div>
      )}
      {cell.row.original.maxUsers && (
        <div>
          <strong>Max users:</strong> {cell.row.original.maxUsers}
        </div>
      )}
    </div>
  );
}

function Reward({ cell }) {
  const [balance, setBalance] = React.useState("");
  const [loading, setLoading] = React.useState(false);

  const userNotClaimed = useMemo(
    () => cell.row.original.users.filter((user) => !user.claimed),
    [cell.row.original.users],
  );

  const balanceColor = useMemo(() => {
    if (+balance >= cell.row.original.rewardPerUser * userNotClaimed.length) {
      return "green";
    }
    return "red";
  }, [balance, cell.row.original.rewardPerUser, userNotClaimed]);

  function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
    toast.success(`Copied: ${text}`);
  }

  async function getErc20Balance() {
    setLoading(true);
    try {
      const provider = new ethers.providers.JsonRpcProvider(chainRpc);
      const contract = new Contract(cell.row.original.rewardCoin, erc20Abi, provider);
      const questAddress = await getQuestAddress(cell.row.original.chainId);
      const balanceInWei = await contract.balanceOf(questAddress);
      const decimals = await contract.decimals();

      setBalance(ethers.utils.formatUnits(balanceInWei, decimals));
    } catch (e) {
      console.log(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div>
          <strong>Reward coin:</strong> {cell.row.original.rewardCoinSymbol}
        </div>
        <FileCopy
          style={{ marginLeft: 10, cursor: "pointer" }}
          onClick={() => copyToClipboard(cell.row.original.rewardCoin)}
        />
      </div>

      <div>
        <strong>Per user:</strong> {cell.row.original.rewardPerUser}{" "}
        {cell.row.original.rewardCoinSymbol}
      </div>

      <div>
        <strong>Need:</strong> {cell.row.original.rewardPerUser * userNotClaimed.length}{" "}
        {cell.row.original.rewardCoinSymbol}
      </div>

      <div>
        <strong>Contract balance:</strong>
        {balance ? (
          <strong style={{ color: balanceColor }}>
            {balance} {cell.row.original.rewardCoinSymbol}
          </strong>
        ) : (
          <button
            onClick={getErc20Balance}
            disabled={loading}
            role="button"
            className="btn btn-info"
          >
            {loading ? "Loading..." : "Get contract balance"}
          </button>
        )}
      </div>
    </div>
  );
}
